<template lang="pug">
.resident-diff-detail-modal-for-cooperation-system
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    .resident(v-if="_item")
      .diff-item.mb-3(v-for="item in _itemColumns" :class="{ 'diff-border': item.before != item.after }")
        .template-item.d-flex.flex-column
          //- lebels
          .item-label {{ item.label }}
          //- before value
          .item-text.d-flex.flex-row
            span.warning-message(v-if="!item.before") 未入力
            span(v-else) {{ convertValue(item.before, item.type) }}
          //- arrow
          .diff-arrow.mb-1(v-if="item.before != item.after")
            .arrow-down-icon
          //- after value
          .item-text.d-flex.flex-row(v-if="item.before != item.after")
            span.warning-message(v-if="!item.after") 未入力
            span(v-else) {{ convertValue(item.after, item.type) }}
      
      .diff-item(v-if="useSystem == 'iMedic'")
        .template-item.d-flex.flex-column
          //- lebels
          .item-label.mb-2 入所・退所情報
          .diff-item.mb-3(v-for="(item, index) in _inoutDatetimeItemColumn.beforeDatetimes")
            //- 差分無し、または末尾以外の入所退所情報
            .before-item(v-if="_inoutDatetimeItemColumn.isDifferent == false || index != _inoutDatetimeItemColumn.beforeDatetimes.length - 1")
              .template-item.d-flex.flex-column
                //- lebels
                .item-label 入所日／入所予定日
                //- before value
                .item-text.d-flex.flex-row
                  span.warning-message(v-if="!item.inDatetime") 未入力
                  span(v-else) {{ convertValue(item.inDatetime, 'date') }}
              .template-item.d-flex.flex-column
                //- lebels
                .item-label 退所日／退所予定日
                //- before value
                .item-text.d-flex.flex-row
                  span.warning-message(v-if="!item.outDatetime") 未入力
                  span(v-else) {{ convertValue(item.outDatetime, 'date') }}
            //- 差分有り、かつ末尾の入所退所情報（差分を表示する）
            .after-item(v-else class="diff-border")
              .template-item.d-flex.flex-column
                //- lebels
                .item-label 入所日／入所予定日
                //- before value
                .item-text.d-flex.flex-row
                  span.warning-message(v-if="!item.inDatetime") 未入力
                  span(v-else) {{ convertValue(item.inDatetime, 'date') }}
                //- arrow
                .diff-arrow.mb-1
                  .arrow-down-icon
                //- after value
                .item-text.d-flex.flex-row
                  span.warning-message(v-if="!_inoutDatetimeItemColumn.afterDatetime.inDatetime") 未入力
                  span(v-else) {{ convertValue(_inoutDatetimeItemColumn.afterDatetime.inDatetime, 'date') }}
              .template-item.d-flex.flex-column
                //- lebels
                .item-label 退所日／退所予定日
                //- before value
                .item-text.d-flex.flex-row
                  span.warning-message(v-if="!item.outDatetime") 未入力
                  span(v-else) {{ convertValue(item.outDatetime, 'date') }}
                //- arrow
                .diff-arrow.mb-1
                  .arrow-down-icon
                //- after value
                .item-text.d-flex.flex-row
                  span.warning-message(v-if="!_inoutDatetimeItemColumn.afterDatetime.outDatetime") 未入力
                  span(v-else) {{ convertValue(_inoutDatetimeItemColumn.afterDatetime.outDatetime, 'date') }}

</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ResidentsForCooperationSystemTableItem } from "./ResidentsForCooperationSystemTable.vue";

import FormLabel from "@/pc/components/forms/FormLabel.vue";
import { InAndOutDatetime } from "@/commons/services/Residents";
import { UseSystem } from "@/pc/pages/residents/GetResidentsForCooperationSystem.vue";

@Component({
  components: {
    FormLabel
  }
})
export default class ResidentDetailModalForCooperationSystem extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  @Prop()
  item!: ResidentsForCooperationSystemTableItem;

  @Prop()
  useSystem!: UseSystem;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _item(): ResidentsForCooperationSystemTableItem | null {
    return this.item ? this.item : null;
  }

  get _itemColumns(): Array<DiffItem> {
    const diffItems: Array<DiffItem> = [];
    // 利用者名
    diffItems.push({ label: "利用者名", before: this.item.name, after: this.item.csResidentName, type: "string" });
    // 利用者名（ふりがな）
    diffItems.push({ label: "利用者名（ふりがな）", before: this.item.kanaName, after: this.item.csResidentKanaName, type: "string" });
    // 性別
    diffItems.push({ label: "性別", before: this.item.gender, after: this.item.csGender, type: "string" });
    // 生年月日
    diffItems.push({ label: "生年月日", before: this.item.birthday, after: this.item.csBirthday, type: "date" });
    // 電話番号
    // ケアサポートから電話番号の情報は送られてこないのでbeforeとafterの値は同じものを使用する
    diffItems.push({ label: "電話番号", before: this.item.tel, after: this.item.csTel, type: "string" });
    // 部屋
    diffItems.push({ label: "部屋", before: this.item.room, after: this.item.csRoomName, type: "string" });
    // 利用者グループ
    // ケアサポートから利用者グループの情報は送られてこないのでbeforeとafterの値は同じものを使用する
    diffItems.push({ label: "利用者グループ", before: this.item.residentGroupName, after: this.item.residentGroupName, type: "string" });
    // 保険者番号
    diffItems.push({ label: "保険者番号", before: this.item.insuredNumber, after: this.item.csInsuredNumber, type: "string" });
    // 介護保険被保険者番号
    diffItems.push({ label: "介護保険被保険者番号", before: this.item.careInsuranceInsuredNumber, after: this.item.csCareInsuranceInsuredNumber, type: "string" });
    return diffItems;
  }

  /**
   * ### データを比較して、以下の仕様通りの差分表示データを作る
   *
   * - i-Medicの入所日・退所日のセットが、HitomeQコネクトの入所日・退所日の配列のどれかと一致する場合は、差分無しとして扱う
   * - i-Medicの入所日・退所日が存在しない場合は差分無しとして扱う
   * - どれとも一致しない場合はi-Medicのデータを差分として扱う
   *   - HitomeQコネクトの入所日・退所日の配列の末尾を上書きするような差分表示にしたい
   * - i-Medicのデータは時間は0時0分0秒で良い
   */
  get _inoutDatetimeItemColumn(): { isDifferent: boolean; beforeDatetimes: Array<InAndOutDatetime>; afterDatetime: InAndOutDatetime | null } {
    const dataA: Array<InAndOutDatetime> = this.item.inAndOutDatetimes ? this.item.inAndOutDatetimes : [];
    const dataB: Array<InAndOutDatetime> = [];
    if (this.item.csInDatetime || this.item.csOutDatetime) {
      dataB.push({
        inDatetime: this.item.csInDatetime,
        outDatetime: this.item.csOutDatetime,
        pickUpDatetime: null,
        dropOffDatetime: null,
        roomId: this.item.roomId as number
      });
    }
    return this.createInAndOutDatetimeDiff(dataA, dataB);
  }

  /**
   * ### HitomeQのデータにi-Medicのデータを取り込むような差分表示データを作成する
   */
  private createInAndOutDatetimeDiff(
    dataA: Array<InAndOutDatetime>,
    dataB: Array<InAndOutDatetime>
  ): { isDifferent: boolean; beforeDatetimes: Array<InAndOutDatetime>; afterDatetime: InAndOutDatetime | null } {
    // データBにinAndOutDatetimesが存在しない場合は、何もせずにdataAを返す
    if (!dataB || dataB.length === 0) {
      return { isDifferent: false, beforeDatetimes: dataA, afterDatetime: null };
    }

    // データBのinAndOutDatetimesは1つまたは0個という前提
    const newEntry = dataB[0];

    // データAのinAndOutDatetimesをループし、inDatetimeとoutDatetimeが一致するものを探す
    const isMatchFound = dataA.some((entry) => {
      // データAは時刻が入力されているので、日付だけにして比較する必要がある
      let _inDatetimeFromDateA = null;
      if (entry.inDatetime) {
        _inDatetimeFromDateA = Number(this.$dateUtil.convertNumberToString(entry.inDatetime, "yyyymmdd"));
      }
      let _outDatetimeFromDateA = null;
      if (entry.outDatetime) {
        _outDatetimeFromDateA = Number(this.$dateUtil.convertNumberToString(entry.outDatetime, "yyyymmdd"));
      }

      // データB日付だけにする
      let _inDatetimeFromDateB = null;
      if (newEntry.inDatetime) {
        _inDatetimeFromDateB = Number(this.$dateUtil.convertNumberToString(newEntry.inDatetime, "yyyymmdd"));
      }
      let _outDatetimeFromDateB = null;
      if (newEntry.outDatetime) {
        _outDatetimeFromDateB = Number(this.$dateUtil.convertNumberToString(newEntry.outDatetime, "yyyymmdd"));
      }

      return _inDatetimeFromDateA === _inDatetimeFromDateB && _outDatetimeFromDateA === _outDatetimeFromDateB;
    });

    // 一致するデータが見つかった場合、取り込まないでそのままdataAを返す
    if (isMatchFound) {
      return { isDifferent: false, beforeDatetimes: dataA, afterDatetime: null };
    }

    // 一致しない場合かつ、データAが空要素であれば初期値データを追加する
    if (dataA.length === 0) {
      dataA.push({
        inDatetime: null,
        outDatetime: null,
        pickUpDatetime: null,
        dropOffDatetime: null,
        roomId: this.item.roomId as number
      });
    }

    return {
      isDifferent: true,
      beforeDatetimes: dataA,
      afterDatetime: {
        inDatetime: newEntry.inDatetime,
        outDatetime: newEntry.outDatetime,
        pickUpDatetime: newEntry.inDatetime,
        dropOffDatetime: newEntry.outDatetime,
        roomId: this.item.roomId as number
      }
    };
  }

  convertValue(value: number | string, type: "date" | "string"): string {
    switch (type) {
      case "date": {
        return this.$dateUtil.convertNumberToString(value as number, "yyyy年mm月dd日");
      }
      case "string": {
        return value as string;
      }
      default: {
        return "";
      }
    }
  }
}

export interface DiffItem {
  /** 項目名 */
  label: string;
  /** 変更前値 */
  before: any;
  /** 変更後値 */
  after: any;
  /** 表示種別 */
  type: "date" | "string";
}

export interface InAndOutDatetimeDiffItem {
  /** 変更前値 */
  before: InAndOutDatetime;
  /** 変更後値 */
  after: InAndOutDatetime;
  /** 表示種別 */
  type: "date" | "string";
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.diff-item {
  font-size: 18px;
  margin: 0 20px;

  .item-label {
    font-weight: bold;
  }
}
.diff-arrow {
  .arrow-down-icon {
    @include svg-icon("../../../assets/arrow-down.svg", $validation-label-font-color, 20px, 20px);
  }
}
.diff-border {
  border: 1px solid $font-strong-color;
  padding: 4px !important;
}
</style>
